import { RefreshIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

const Loader = () => {
  const { t } = useTranslation();

  return (
    <div className="flex grow items-center justify-center min-h-full">
      <RefreshIcon className="animate-spin h-5 mr-2 w-5" />
      <span>{t("Loading")}</span>
    </div>
  );
};

export default Loader;
